import OptionsModalComponent from "./OptionsModalComponent";

export default OptionsModalComponent;
